<template>
  <div class="page user-page">
    <h2 class="page-title">用户管理</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="关键词"><el-input v-model="query.keyword" placeholder="昵称/电话" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="角色">
              <el-select v-model="query.role" clearable placeholder="全部">
                <el-option label="普通用户" :value="1" /><el-option label="守望者" :value="2" /><el-option label="管理员" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="状态">
              <el-select v-model="query.status" clearable placeholder="全部">
                <el-option label="正常" :value="1" /><el-option label="封禁" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button @click="exportList">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="用户" min-width="180">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="42" :src="scope.row.avatarUrl" icon="el-icon-user-solid" />
              <div>
                <div class="main-text">{{ scope.row.nickname || '-' }}</div>
                <div class="sub-text">{{ scope.row.phone || '-' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="110">
          <template slot-scope="scope">
            <el-tag :type="roleType(scope.row.role)">{{ roleText(scope.row.role) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="integral" label="积分" width="90" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">{{ scope.row.status === 1 ? '正常' : '封禁' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text" @click="toggleStatus(scope.row)" :style="{ color: scope.row.status === 1 ? '#f56c6c' : '#67c23a' }">
                {{ scope.row.status === 1 ? '封禁' : '解封' }}
              </span>
              <span class="action-text edit" @click="openRoleEdit(scope.row)">改角色</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <el-dialog title="修改角色" :visible.sync="roleVisible" width="360px">
      <el-form :model="roleForm" label-width="70px">
        <el-form-item label="用户">{{ roleRow && roleRow.nickname }}</el-form-item>
        <el-form-item label="角色">
          <el-radio-group v-model="roleForm.role">
            <el-radio :label="1">普通用户</el-radio>
            <el-radio :label="2">守望者</el-radio>
            <el-radio :label="3">管理员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="roleVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRole">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchUsers, updateUserStatus, updateUserRole, deleteUser } from '@/api'

export default {
  data() {
    return {
      loading: false,
      tableData: [], total: 0,
      query: { pageNum: 1, pageSize: 10, keyword: '', role: undefined, status: undefined },
      roleVisible: false, roleRow: null,
      roleForm: { id: null, role: 1 }
    }
  },
  watch: {
    'query.keyword'() { this.handleSearch() },
    'query.role'() { this.handleSearch() },
    'query.status'() { this.handleSearch() }
  },
  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchUsers(params)
        const records = res.records || []
        records.forEach(row => {
          const url = row.avatarUrl || ''
          if (!url || url.startsWith('tmp/') || /^https?:\/\/tmp\//i.test(url) || url.startsWith('/static/')) {
            row.avatarUrl = ''
          }
        })
        this.tableData = records; this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() { this.query = { pageNum: 1, pageSize: 10, keyword: '', role: undefined, status: undefined }; this.loadData() },
    async toggleStatus(row) {
      const next = row.status === 1 ? 2 : 1
      const label = next === 2 ? '封禁' : '解封'
      try {
        await this.$confirm('确认' + label + '用户「' + (row.nickname || row.phone) + '」？', label + '确认', { type: 'warning' })
        await updateUserStatus({ id: row.id, status: next })
        this.$message.success(label + '成功'); this.loadData()
      } catch (e) {}
    },
    openRoleEdit(row) { this.roleRow = row; this.roleForm = { id: row.id, role: row.role || 1 }; this.roleVisible = true },
    async submitRole() {
      await updateUserRole(this.roleForm)
      this.$message.success('角色已更新'); this.roleVisible = false; this.loadData()
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除用户「' + (row.nickname || row.phone) + '」？此操作不可恢复。', '删除确认', { type: 'warning' })
        await deleteUser(row.id); this.$message.success('已删除'); this.loadData()
      } catch (e) {}
    },
    exportList() {
      const h = ['ID', '昵称', '电话', '角色', '积分', '状态', '注册时间']
      const r = this.tableData.map(row => [row.id, row.nickname, row.phone, this.roleText(row.role), row.integral, row.status === 1 ? '正常' : '封禁', this.formatDateTime(row.createdAt)])
      const csv = [h, ...r].map(items => items.map(v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"').join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a'); link.href = URL.createObjectURL(blob); link.download = '用户列表_' + new Date().toISOString().slice(0, 10) + '.csv'; link.click(); URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' },
    roleText(v) { return v === 1 ? '普通用户' : v === 2 ? '守望者' : v >= 3 ? '管理员' : '普通用户' },
    roleType(v) { return v >= 3 ? 'danger' : v === 2 ? 'success' : '' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input, .filter-form ::v-deep .el-select { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.user-cell { display: flex; align-items: center; gap: 10px; }
.main-text { color: #333; font-weight: 600; line-height: 20px; }
.sub-text { color: #909399; font-size: 12px; line-height: 18px; }
.action-bar { display: flex; align-items: center; gap: 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.edit { color: #409eff; }
.action-text.delete { color: #f56c6c; }
</style>
